import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { createStreamEpic } from './_epic/createStream.epic';
import { endStreamProcessingEpic } from './_epic/endStreamProcessing.epic';
import { loadStreamListEpic } from './_epic/loadStreamList.epic';
import { loadStreamEpic } from './_epic/loadStream.epic';
import { reloadStreamListEpic } from './_epic/reloadStreamList.epic';
import { removeStreamDoneEpic } from './_epic/removeStreamDone.epic';
import { startStreamProcessingEpic } from './_epic/startStreamProcessing.epic';
import { updateStreamEpic } from './_epic/updateStream.epic';
import { removeStreamEpic } from './_epic/removeStream.epic';

export const streamEpic = safeCombineEpics(
  createStreamEpic,
  endStreamProcessingEpic,
  loadStreamListEpic,
  loadStreamEpic,
  reloadStreamListEpic,
  removeStreamEpic,
  removeStreamDoneEpic,
  startStreamProcessingEpic,
  updateStreamEpic,
);
